import type en from '../en/subscriptions'
import type { Translation } from '../types'

/** Alert subscriptions: who is told when a network or device goes offline */
const subscriptions: Translation<typeof en> = {
  "subscriptions.scope.SITE": "Solo la red",
  "subscriptions.scope.SITE_AND_DEVICES": "Red + dispositivos",
  "subscriptions.scope.DEVICE": "Un solo dispositivo",
  "subscriptions.blurb.SITE": "Avisa cuando el propio sitio se queda sin conexión",
  "subscriptions.blurb.SITE_AND_DEVICES": "También avisa por cada dispositivo que contiene",
  "subscriptions.blurb.DEVICE": "Avisos solo de un dispositivo",
  "subscriptions.blurbDevices": { one: "También avisa por cada dispositivo que contiene ({count} dispositivo)", other: "También avisa por cada dispositivo que contiene ({count} dispositivos)" },
  "subscriptions.channel.EMAIL": "Correo",
  "subscriptions.unsubscribed": "Suscripción cancelada",
  "subscriptions.testSent": "Prueba enviada por {channels}",
  "subscriptions.someFailed": "Algunos canales han fallado",
  "subscriptions.testFailed": "Error en la prueba",
  "subscriptions.title": "Suscripciones a alertas",
  "subscriptions.subtitle": "Reciba un aviso cuando una red o un dispositivo se quede sin conexión",
  "subscriptions.subscribe": "Suscribirse",
  "subscriptions.noPhone": "No hay número de teléfono",
  "subscriptions.ready": "listo",
  "subscriptions.unavailable": "no disponible",
  "subscriptions.empty": "Todavía no hay suscripciones. Suscríbase a una red para recibir un aviso cuando caiga.",
  "subscriptions.unknown": "Desconocido",
  "subscriptions.paused": "en pausa",
  "subscriptions.alertsAfter": "Aviso tras {duration} sin conexión",
  "subscriptions.reminderEvery": "Recordatorio cada {duration}",
  "subscriptions.reminderEveryMax": "Recordatorio cada {duration} (como máximo {max})",
  "subscriptions.oneMessage": "Un mensaje por caída",
  "subscriptions.recoveryOn": "Aviso de recuperación activado",
  "subscriptions.quiet": "Silencio {from}–{to}",
  "subscriptions.muted": "Silenciados:",
  "subscriptions.unmute": "Reactivar",
  "subscriptions.unmuted": "{name} reactivado",
  "subscriptions.mutedName": "{name} silenciado",
  "subscriptions.muteDevice": "Silenciar un dispositivo de esta red",
  "subscriptions.history": "Historial de envíos",
  "subscriptions.sendTest": "Enviar una prueba",
  "subscriptions.unsubscribe": "Cancelar suscripción",
  "subscriptions.unsubscribeConfirm": "¿Cancelar la suscripción a estas alertas?",
  "subscriptions.historyEmpty": "Todavía no se han enviado alertas: nada se ha quedado sin conexión desde que se suscribió.",
  "subscriptions.target": "Objetivo",
  "subscriptions.downSince": "Sin conexión desde",
  "subscriptions.messages": "Mensajes",
  "subscriptions.state": "Estado",
  "subscriptions.reminders": { one: "({count} recordatorio)", other: "({count} recordatorios)" },
  "subscriptions.state.PENDING": "en espera",
  "subscriptions.state.NOTIFIED": "enviado",
  "subscriptions.state.RECOVERED": "recuperado",
  "subscriptions.newTitle": "Suscribirse a alertas",
  "subscriptions.network": "Red *",
  "subscriptions.chooseNetwork": "Elija una red…",
  "subscriptions.watchWhat": "¿Qué desea vigilar?",
  "subscriptions.device": "Dispositivo *",
  "subscriptions.chooseDevice": "Elija un dispositivo…",
  "subscriptions.sendVia": "Enviar alertas por *",
  "subscriptions.rcsNote": "El RCS llega a la aplicación de mensajes del propio teléfono. Todavía no llega a los iPhone en los Países Bajos.",
  "subscriptions.rcsNoteTwilio": "El RCS llega a la aplicación de mensajes del propio teléfono. Todavía no llega a los iPhone en los Países Bajos; con un número de SMS en el servicio de Twilio reciben un SMS.",
  "subscriptions.howOften": "Con qué frecuencia",
  "subscriptions.wait": "Esperar antes de avisar",
  "subscriptions.waitHint": "minutos: ignora cortes breves y reinicios",
  "subscriptions.remind": "Recordármelo mientras siga sin conexión",
  "subscriptions.remindHint": "Desactivado por defecto: recibe exactamente un mensaje por caída.",
  "subscriptions.every": "cada",
  "subscriptions.remindEvery": "Recordar cada",
  "subscriptions.stopAfter": "parar tras",
  "subscriptions.stopAfterLabel": "Parar tras este número de recordatorios",
  "subscriptions.remindersWord": "recordatorios",
  "subscriptions.recovers": "Avisarme cuando se recupere",
  "subscriptions.recoversHint": "Un mensaje cuando vuelva a estar en línea",
  "subscriptions.quietHours": "Horas de silencio",
  "subscriptions.quietHint": "Los mensajes se retienen hasta que termina la franja",
  "subscriptions.quietStart": "Inicio de las horas de silencio",
  "subscriptions.quietEnd": "Fin de las horas de silencio",
  "subscriptions.to": "a",
  "subscriptions.subscribed": "Suscrito",
  "subscriptions.subscribeFailed": "No se pudo suscribir",
  "subscriptions.devicesIn": "Dispositivos de {name}",
  "subscriptions.muteInfo": "Silencie un dispositivo para detener sus avisos y mantener suscrito el resto de la red.",
  "subscriptions.noDevices": "No se han encontrado dispositivos en esta red",
  "subscriptions.unmuteTitle": "Reactivar: reanudar los avisos",
  "subscriptions.muteTitle": "Silenciar: detener los avisos de este dispositivo",
  "subscriptions.mute": "Silenciar",
  "subscriptions.done": "Listo",
  "subscriptions.notChanged": "Sin cambios",
  "subscriptions.channel.PUSH": "Push (aplicación móvil)",
  "subscriptions.pushPhones": "Teléfonos con push: {n}",
  "subscriptions.pushFirst.first": {"one": "El push va primero. {channel} sigue tras {count} minuto si no ha abierto el sitio.", "other": "El push va primero. {channel} sigue tras {count} minutos si no ha abierto el sitio."},
  "subscriptions.pushFirst.atOnce": "{channel} va de inmediato: ninguno de sus teléfonos permite push (Perfil → Aplicación móvil).",
  "subscriptions.pushFirst.automatic": "El push se envía primero de todos modos para sus alertas de WhatsApp y RCS.",
}

export default subscriptions
